import HistoricalTransactionDetails from './historical-transaction-details.vue'
export default HistoricalTransactionDetails
